import { combineReducers } from 'redux';
import authReducer from './authReducer';
import appReducer from './appReducer';
import delancey from './delancey';
import payment from './payment';
import register from './register';
import buyerSeller from './buyerSeller'
import accountSetting from './accountSetting';
import addGroup from './addGroup';
import postLoad from './postLoad';
import profile from './profile';
import postInventory from './postInventory';
import dashboard from './dashboard';
import checkout from './checkout';
import makeOffer from './makeOffer';
import myOrders from './myOrders';
import myNetwork from './myNetwork';
import withDraw from './withDraw';
import myClaims from './myClaims';
import storedData from './storedData';
import customerReviews from './customerReviews';
import notification from './notification';
import admin from './admin';
import urlParameters from './urlParameters';
import language from './language';
import notificationCount from './notificationCount'

const allReducers = combineReducers({
  authReducer,
  appReducer,
  delancey,
  buyerSeller,
  payment,
  addGroup,
  urlParameters,
  postLoad,
  postInventory,
  register,
  accountSetting,
  profile,
  dashboard,
  checkout,
  makeOffer,
  myOrders,
  myNetwork,
  withDraw,
  customerReviews,
  myClaims,
  notification,
  admin,
  language,
  storedData,
  notificationCount,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_REDUX_STORE') {
    state = undefined;
  }
  return allReducers(state, action);
};

export default rootReducer